// The custom-expense rows a Pricing Summary box shows, and what an edit or "+" saves (D159.1).
// None stored: one unstored "Customs Expense" row, saved the first time it is edited.
// Totals and the charge spread read the STORED list, never these rows.
import type { CustomExpenseDto } from '../../lib/quotationApi';

export const DEFAULT_CUSTOM_EXPENSE_LABEL = 'Customs Expense';

const newRow = (): CustomExpenseDto => ({ label: DEFAULT_CUSTOM_EXPENSE_LABEL, amount: 0, currency: 'USD' });

type Stored = CustomExpenseDto[] | null | undefined;

/** The rows a box shows; `unstored` is true when they are only the default row. */
export function shownCustomExpenses(stored: Stored): { rows: CustomExpenseDto[]; unstored: boolean } {
  return stored?.length ? { rows: stored, unstored: false } : { rows: [newRow()], unstored: true };
}

/** The list to save after "+": a new row at `index` of the shown rows (out of range appends). */
export function customExpensesAfterInsert(stored: Stored, index: number): CustomExpenseDto[] {
  const rows = shownCustomExpenses(stored).rows;
  const at = index >= 0 && index <= rows.length ? index : rows.length;
  return [...rows.slice(0, at), newRow(), ...rows.slice(at)];
}

/** The list to save after editing shown row `index`, or null when the label is blank (a label is required). */
export function customExpensesAfterEdit(stored: Stored, index: number, updates: Partial<CustomExpenseDto>): CustomExpenseDto[] | null {
  if (updates.label !== undefined && !updates.label.trim()) return null;
  const rows = shownCustomExpenses(stored).rows.slice();
  rows[index] = { ...rows[index], ...updates };
  return rows;
}
